module.exports = __webpack_public_path__ + "7fcd8e808a5568814b16fcec3dc7affb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/screens/App/screens/Home/images/paso1.svg
// module id = 1464
// module chunks = 0